import { resolveBrand } from "./brands";

export const BRAND = resolveBrand(import.meta.env.VITE_BRAND);

export default BRAND;
